module.exports = __webpack_public_path__ + "static/work_BigBang_2023_3D-20193a6e98e4dc972e3ba504a60ac1ac.mp4";